<template>
	<div class="m-l-50 m-t-0 w-1200">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="账号" prop="username">
        <el-input v-model.trim="form.username" placeholder="请输入手机号/邮箱" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="user_password">
        <el-input v-model.trim="form.user_password" placeholder="请输入6-16位数字和字母混合密码" class="h-40 w-200"></el-input>
        <el-tooltip class="item" effect="dark" content="不输入则密码不变" placement="right">
          <el-button size="small" class="el-icon-warning">  提示</el-button>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="真实姓名" prop="user_name">
        <el-input v-model.trim="form.user_name" placeholder="请输入真实姓名" class="h-40 w-200"></el-input>
      </el-form-item>
      <!-- <el-form-item label="性别"  prop="sex">
        <el-radio class="radio" v-model="form.sex" :label="1">男</el-radio>
        <el-radio class="radio" v-model="form.sex" :label="2">女</el-radio>
      </el-form-item> -->
      <el-form-item label="用户头像">
        <img style="width:100px;height: 100px;margin-top:6px;" :src='form.user_head?form.user_head:logo2'>
        <el-upload
        class="upload-demo"
        :action="uploadUrl"
        type="drag"
        :thumbnail-mode="true"
        :on-preview="viewPic"
        :on-remove="handleRemove"
        :on-success="uploadSuccess"
        :on-error="uploadFail"
        :default-file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">保 存</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
		</el-form>
	</div>
</template>
<style>
	.form-checkbox:first-child{
		margin-left: 15px;
	}
  .item {
    margin: 4px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        isLoading: false,
        fileList: [],
        propsImg: '',
        id: null,
        form: {
          username: '',
          user_password: '',
          user_name: '',
          user_head: ''
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名' }
          ]
        }
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/user/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      uploadSuccess(res, file, fileList) {
        this.form.user_head = res.data
        let data = {
          name: '图片',
          url: window.HOST + res.data
        }
        if (this.fileList.length) {
          this.fileList[0] = data
        } else {
          this.fileList.push(data)
        }
      },
      uploadFail(err, res, file) {
        console.log('err = ', _g.j2s(err))
        console.log('res = ', _g.j2s(res))
      },
      handleRemove(file, fileList) {
        console.log('file = ', file)
        console.log('fileList = ', fileList)
      },
      viewPic() {
        this.propsImg = this.fileList[0].url
        this.$refs.preview.open()
      },
      async getCompleteData() {
        this.apiGet('admin/user/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.username = data.username
            this.form.user_password = data.user_password
            this.form.user_name = data.user_name
            this.form.user_head = data.user_head
          })
        })
      }
    },
    created() {
      this.uploadUrl = window.HOST + 'qiniu'
      this.id = this.$route.params.id
      this.getCompleteData()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?2d9f8cae